var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUxData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.7 86.7",
    style: {
      enableBackground: "new 0 0 86.7 86.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,39v9.4H27.8V39H39.4 M40.1,38.3h-13v10.9h13L40.1,38.3L40.1,38.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 43.6,
    className: "st0",
    width: 2.5,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3,
    y: 41.4,
    className: "st0",
    width: 2.5,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.7,
    y: 40.2,
    className: "st0",
    width: 2.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1,
    y: 32.3,
    className: "st0",
    width: 12.9,
    height: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.6,32.3c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0.1v12.5c0,1.4,0.8,2.3,2,2.3s2-0.9,2-2.3V32.6 c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0,0h1.5c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0.1V45c0,2.6-1.6,4.4-4.1,4.4s-4.2-1.8-4.2-4.4V32.6 c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0,0H43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.3,37.3L59.3,37.3c-0.3,0.1-0.6,0.3-0.9,0.4c-0.3,0.1-0.7,0.2-1,0.2h-0.3c-0.1,1-0.9,1.7-1.9,1.8 c-1.1,0-2-1-1.9-2.1c0,0,0-0.1,0-0.1v-4.8c0-0.2-0.1-0.3-0.3-0.3c0,0,0,0-0.1,0h-1.5c-0.2,0-0.3,0.1-0.3,0.3c0,0,0,0,0,0.1v4.7 c-0.1,1.3,0.6,2.6,1.7,3.3c-1.1,0.8-1.8,2-1.7,3.4v4.9c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0.1,0H53c0.2,0,0.3-0.1,0.3-0.3 c0,0,0,0,0-0.1v-5c-0.1-1.1,0.6-2,1.7-2.1c1.1-0.1,2,0.6,2.1,1.7c0,0.2,0,0.3,0,0.5v5c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0.1,0H59 c0.2,0,0.3-0.1,0.3-0.3c0,0,0,0,0-0.1V44c0-1.3-0.6-2.6-1.7-3.3C58.8,39.9,59.4,38.7,59.3,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.3,26.5c-0.2,0.7-0.5,1.4-0.9,2c-0.8,1.5-1.8,2.9-2.8,4.2c-0.3,0.3-0.6,0.7-0.9,1c-0.1,0.1-0.1,0.1-0.2,0 c-0.3-0.5-0.8-0.8-1.3-1l-0.1,0c0.2-0.3,0.3-0.6,0.5-0.9c0.7-0.9,1.4-1.8,2.2-2.6c0.8-0.8,1.7-1.6,2.6-2.5 c0.2-0.2,0.4-0.3,0.6-0.4c0.1,0,0.2,0,0.3,0L65.3,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,36.5c0.4-0.6,0.6-1.2,0.5-1.9c0-0.2,0-0.3,0.1-0.5c0.1-0.6,0.7-0.9,1.3-0.8c0.1,0,0.1,0,0.2,0.1 c0.4,0.1,0.8,0.5,1,0.9c0.2,0.3,0.1,0.7-0.1,1c-0.5,0.6-1.1,1-1.9,1.2c-0.2,0.1-0.5,0.1-0.7,0.1c-0.1,0-0.2,0-0.3,0 C57,36.6,57,36.5,57,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62,34l-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c0,0.5-0.1,1.1-0.5,1.5l0,0v14.6H25.8V30.9h33.1 c0.3-0.5,0.7-0.9,1-1.3H25.1c-0.4,0-0.6,0.3-0.6,0.6v21c0,0.4,0.3,0.6,0.6,0.6h17v6.3h5.5v-6.3h13.9c0.4,0,0.6-0.3,0.7-0.6V33.8 L62,34z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 58.9,
    className: "st0",
    width: 23.2,
    height: 1.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxData);
export default __webpack_public_path__ + "static/media/ux-data.1cf877b5ef9657cf7971dcc5605515da.svg";
export { ForwardRef as ReactComponent };